import React from 'react';
import PropTypes from 'prop-types';
import {
  SmallLabelCell,
  TagListCell,
} from 'base/components/table/Cells';
import SmallLabel from 'base/components/SmallLabel';
import Date from 'base/components/Date';
import CheckboxDataTable from 'base/components/table/CheckboxDataTable';
import {
  getDeleteColumn,
  getEditColumn,
  getCloneColumn,
  getShareColumn,
  getDefaultFavoritesColumn,
} from 'base/components/table/RowActionButton';
import withGlobalFilter from 'base/components/table/withGlobalFilter';
import getCacheOfflineColumn from 'offline/util/getCacheOfflineColumn';
import { LargeLabelLink } from 'base/components/LargeLabel';
import MimeTypeIcon from '../MimeTypeIcon/index';
import { getFavoriteColumn } from '../../../favorites';


const FormatCell = ({ row }) => // eslint-disable-line
  <MimeTypeIcon mimeType={row.format} />;

const NameCell = ({ row, original }) => { // eslint-disable-line
  return (
    <LargeLabelLink
      isPrimary={original.entityType === 'document'}
      to={original.route}
      href={original.route}
    >
      {row.name}
    </LargeLabelLink>
  );
};


const DateCell = ({ row }) => // eslint-disable-line
  <SmallLabel><Date date={row.lastModifiedAt} /></SmallLabel>;


const FilteredTable = withGlobalFilter(CheckboxDataTable);


const FileExplorer = ({
  data,
  onRowEdit,
  onRowClone,
  onRowDelete,
  onRowFavoriteToggle,
  onRowCacheOfflineToggle,
  onDefaultFavoriteEdit,
  onShare,
  usersById,
  tagsById,
  columnsCallback,
  isAdmin,
  authorities,
  ...other
}) => {
  const columns = columnsCallback([
    {
      Header: 'Type',
      id: 'format',
      accessor: (d) => (d.file ? d.file.mime : 'folder'),
      Cell: FormatCell,
      width: 60,
    },
    {
      Header: 'Name',
      id: 'name',
      accessor: 'name',
      Cell: NameCell,
      showOnMobile: true,
    },
    {
      Header: 'Date',
      accessor: 'lastModifiedAt',
      Cell: DateCell,
      width: 120,
    },
    {
      Header: 'Author',
      id: 'createdBy',
      width: 160,
      accessor: (row) => usersById[row.createdBy] && usersById[row.createdBy].fullName,
      Cell: SmallLabelCell('createdBy'),
    },
    {
      Header: 'Tag',
      id: 'tags',
      width: 120,
      accessor: row => { // eslint-disable-line
        return (row.tags ? row.tags.map((tag) => (tagsById[tag] ? tagsById[tag].name : '')) : []);
      },
      Cell: TagListCell('tags'),
    },
    getShareColumn(onShare),
    getFavoriteColumn(onRowFavoriteToggle),
    getCacheOfflineColumn(onRowCacheOfflineToggle),
    getEditColumn(onRowEdit),
    getCloneColumn(onRowClone),
    getDeleteColumn(onRowDelete),
  ]);

  if (isAdmin || authorities.includes('DEFAULT_FAVORITES_ADMIN')) {
    columns.splice(-2, 0, getDefaultFavoritesColumn(onDefaultFavoriteEdit));
  }

  return (
    <FilteredTable
      data={data}
      columns={columns}
      filterKeys={[
        'name',
      ]}
      filterLabel="Filter by name..."
      {...other}
    />
  );
};
FileExplorer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  onRowEdit: PropTypes.func.isRequired,
  onRowClone: PropTypes.func.isRequired,
  onRowDelete: PropTypes.func.isRequired,
  onRowFavoriteToggle: PropTypes.func.isRequired,
  onShare: PropTypes.func.isRequired,
  onRowCacheOfflineToggle: PropTypes.func.isRequired,
  onDefaultFavoriteEdit: PropTypes.func.isRequired,
  usersById: PropTypes.objectOf(PropTypes.any).isRequired,
  tagsById: PropTypes.objectOf(PropTypes.any).isRequired,
  columnsCallback: PropTypes.func,
  isAdmin: PropTypes.bool,
  authorities: PropTypes.arrayOf(PropTypes.any).isRequired,
};
FileExplorer.defaultProps = {
  columnsCallback: (cols) => cols,
  isAdmin: false,
};

export default FileExplorer;
